import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ErrorBoundary } from '@components/ErrorBoundary';
import { AuthCallback } from '@components/AuthCallback';
import { CodeGraphWrapper } from '@components/CodeGraphWrapper';
import { DBModernizationWrapper } from '@components/DBModernizationWrapper';
import { BuildSoftwareWrapper } from '@components/BuildSoftwareWrapper';
import { LoginPage } from '@login/LoginPage';
import { DashboardPage } from '@dashboard/DashboardPage';
import { ProjectsPage } from '@projects/ProjectsPage';
import { CodeAnalysisPage } from '@codeanalysis/CodeAnalysisPage';
import { ModOutputPage } from '@modoutput/ModOutputPage';
import { Layout } from './Layout';
import { ProtectedRoute } from './ProtectedRoute';

/**
 * Main App component with routing configuration
 */
function App() {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/auth/callback" element={<AuthCallback />} />

          <Route
            path="/"
            element={
              <ProtectedRoute>
                <Layout />
              </ProtectedRoute>
            }
          >
            <Route index element={<Navigate to="/dashboard" replace />} />
            <Route path="dashboard" element={<DashboardPage />} />
            <Route path="projects" element={<ProjectsPage />} />
            <Route path="codeanalysis/:projectId" element={<CodeAnalysisPage />} />
            <Route path="workspace/code-graph/new" element={<CodeGraphWrapper />} />
            <Route path="workspace/code-graph/:projectId" element={<CodeGraphWrapper />} />
            <Route path="workspace/db-modernization/*" element={<DBModernizationWrapper />} />
            <Route path="workspace/build-software" element={<BuildSoftwareWrapper />} />
            <Route path="workspace/build-software/:projectId" element={<BuildSoftwareWrapper />} />
            <Route path="modernization-output" element={<ModOutputPage />} />
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Route>

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </ErrorBoundary>
  );
}

export default App;
